import isNil from "lodash/isNil";
import partition from "lodash/partition";

import { Repo } from "@pages/projects/types";

// For now, we consider a repo "setup" if it has been provisioned or has
// been scanned. "setup" repos are for the Project List tab, "not setup"
// repos are potential GitHub repos that could be onboarded on the
// Project Setup tab
export const partitionSetupRepos = (repos: Repo[]) => {
  // Do not display repos that have been deleted or archived on github
  const activeRepos = repos?.filter(
    (r) => !r.is_archived && !r.is_disconnected
  );
  const [setupRepos, notSetupRepos] = partition(
    activeRepos,
    (repo) => !isNil(repo.provisioned_at) || !isNil(repo.latest_scan_at)
  );

  return { setupRepos, notSetupRepos };
};
